import Application from '@ember/application';

import { isTesting, macroCondition } from '@embroider/macros';

import { TestSharedHistoryLocation } from '../react/utils/test/shared-history-location';

export function initialize(application: Application) {
  if (macroCondition(isTesting())) {
    application.register('location:shared-history', new TestSharedHistoryLocation(), {
      instantiate: false,
    });
  }
}

export default {
  name: 'register-location',
  initialize,
};
